import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUnites, Unites } from '../models/unites.model';
import { InlineResponse } from '../models/inline-response.model';
import { environment } from '../../../environments/environment';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UnitesClientService {
  private apiUrl = environment.apiURL;

  constructor(private http: HttpClient) {}

  public getUnitesData(): Observable<IUnites> {
    return this.http.get<IUnites>(this.apiUrl + '/services/unite');
  }

  public addUnitesData(codeCourt: string, codeHecate: number, designation: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('codeCourt', codeCourt.toString())
      .set('codeHecate', codeHecate.toString())
      .set('designation', designation)
      .set('oper', 'add')
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString());

    console.log(params);

    return this.http.post<any>(this.apiUrl + '/services/unite', params, options);
  }

  public updateUnitesData(unites: Unites): Observable<InlineResponse> {
    let params = new HttpParams().set('codeCourt', unites.codeCourt).set('codeHecate', unites.codeHecate).set('designation', unites.designation).set('oper', 'edit').set('id', unites.id);

    return this.http.post<InlineResponse>(this.apiUrl + '/services/unite', params, options);
  }
}
